import { Icon } from "@core/icons";
import { tokens } from "@core/theme/tokens";

// Señal visual de que el marco de vista previa (celular) se puede desplazar
// (revisión en vivo 2026-09-22, punto #13). El marco usa `.scr-scroll`, que
// oculta la barra a propósito (base.css, réplica de `.noscroll` del
// prototipo), así que no queda ninguna pista de que hay más contenido abajo.
// Para teclado ya estaba resuelto con `role="region"` + `tabIndex`; esto
// cubre a quien mira la pantalla.
//
// Compartido entre "Pantalla de bienvenida" y "Pantalla de inicio" — los dos
// únicos marcos con este patrón — en vez de duplicar el bloque en ambas.
// `chevdown` ya existe en el set de íconos; no se agregó ninguno nuevo.
export function PreviewScrollHint() {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 6,
        marginTop: 10,
        font: `400 11px/1.5 ${tokens.font.ui}`,
        color: tokens.text.tertiary,
      }}
    >
      <span aria-hidden="true" style={{ display: "flex" }}>
        <Icon name="chevdown" size={13} />
      </span>
      Desliza para ver más
    </div>
  );
}
